module.exports = __webpack_public_path__ + "img/pen-icon.df75730b.svg";